import React, { useState, useMemo } from "react";
import { Modal, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import dayjs from "../../../util/dayjs-config";
import { CheckmarkSquare, DashboardEdit, DismissSquare } from "../../../assets/icons";
import { getInitials } from "../../../util/general-helpers";
import { Link } from "react-router-dom";
import "./dashboard-utils.scss"
import { FluentBadge } from "../../../components/FluentUI/Fluent-Badge";
import { FluentTooltip } from "../../../components/FluentUI/Fluent-Tooltip";

export const onHandleHover = (e) => {
  e.target.style.textDecoration = "underline";
};

export const onHandleHoverDone = (e) => {
  e.target.style.textDecoration = "";
};

export const onHandleHoverEmpty = (e) => {
  e.target.style.cursor = "not-allowed";
};

export const getSetToggled = (items) => {
  return items.map(function (m) {
    let tog = {
      "UserId": m.UserId,
      "Toggled": false
    };
    return tog;
  });
}

export const getSetToggledHealthcare = (items) => {
  return items.map(function (m) {
    let tog = {
      "UserID": m.UserID,
      "Toggled": false
    };
    return tog;
  });
}

export const getSetToggledFig = (items) => {
  return items.map(function (m) {
    let tog = {
      "UserID": m.Id,
      "Toggled": false
    };
    return tog;
  });
}

export const getDateColor = (color) => {
  switch (color) {
    case "red":
      return "#C11919";
    case "gray":
      return "#696969";
    case "yellow":
      return "#F29A1D";
    case "black":
      return "#121212";
    default:
      return "";
  }
};

export const getLastUpdatedDateColor = (LastUpdated) => {
  if (LastUpdated === "-" || LastUpdated === "—" || LastUpdated === null) {
    return "#121212"; //black
  }
  let last = dayjs(LastUpdated);
  let now = dayjs();
  let days = now.diff(last, "day", true);
  if (days <= 3)
    return "#121212"; //black
  else if (days <= 7)
    return "#F29A1D"; //yellow
  else
    return "#C11919"; //red
};

export const getLastUpdatedDateColorWeeks = (LastUpdated) => {
  if (LastUpdated === "-" || LastUpdated === "—" || LastUpdated === null) {
    return "#121212"; //black
  }
  let last = dayjs(LastUpdated);
  let now = dayjs();
  let days = now.diff(last, "day", true);
  if (days <= 7)
    return "#121212"; //black
  else if (days <= 14)
    return "#F29A1D"; //yellow
  else
    return "#C11919"; //red
};

export const getLastUpdatedTootlTip = (body) => {
  return (
    <OverlayTrigger
      placement={"bottom"}
      delay={{ show: 150, hide: 150 }}
      overlay={
        <Tooltip className="actionToolTip">
          <div className='consumerRetailBlack tooltipCRbox'></div><div className="whiteText">Updated within the last three days</div>
          <div className='consumerRetailYellow tooltipCRbox'></div><div className="whiteText">Updated more than three days ago, but less than a week ago</div>
          <div className='consumerRetailRed tooltipCRbox'></div><div className="whiteText">Updated more than a week ago</div>
        </Tooltip>
      }>
      {body}
    </OverlayTrigger>
  )
}

export const getBookedVacationTooltip = (body) => {
  return (
    <OverlayTrigger
      placement={"bottom"}
      delay={{ show: 150, hide: 150 }}
      overlay={
        <Tooltip className="bookedVacationToolTip">
          <div className='consumerRetailBlack tooltipCRbox'></div><div className="whiteText">Upcoming</div>
          <div className='consumerRetailYellow tooltipCRbox'></div><div className="whiteText">Two weeks away</div>
          <div className='consumerRetailRed tooltipCRbox'></div><div className="whiteText">One week away</div>
        </Tooltip>
      }>
      {body}
    </OverlayTrigger>
  )
}

export const getBookedVacationTooltipForRE = (body) => {
  return (
    <OverlayTrigger
      placement={"bottom"}
      delay={{ show: 150, hide: 150 }}
      overlay={
        <Tooltip className="bookedVacationToolTip">
          <div className='consumerRetailBlack tooltipCRbox'></div><div className="whiteText">{">"} Two weeks</div>
          <div className='consumerRetailYellow tooltipCRbox'></div><div className="whiteText">Two weeks away</div>
          <div className='consumerRetailRed tooltipCRbox'></div><div className="whiteText">One week away</div>
        </Tooltip>
      }>
      {body}
    </OverlayTrigger>
  )
}

export const renderTable = (table) => {
  var result = null;
  if (table != null && table.Columns != null) {
    result = (
      <Table className="levfin-table">
        <thead className="header sticky-row">
          <tr>
            {table.Columns.map((m) => {
              return <th key={m.Id}>{m.Name}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {table.Rows.map((tdata) => {
            return (
              <tr key={tdata?.Id} className={getActiveColor(tdata)}>
                {tdata.Data.map((trowdata) => {
                  return <td key={trowdata?.Id}>{trowdata.Value}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
  return result;
};

const getActiveColor = (tdata) => {
  let activeIndex = tdata?.Data?.findIndex((x) => x.Value?.toLowerCase() === "active".toLowerCase());
  if (activeIndex > -1) {
    return "levfin-active-row";
  }
  let InActiveIndex = tdata?.Data?.findIndex((x) => x.Value?.toLowerCase() === "inactive".toLowerCase());
  if (InActiveIndex > -1) {
    return "levfin-inactive-row";
  }
}

export const renderTableVacation = (table) => {
  let result = [];
  result = (
    <div>
      <Modal.Title className="popup-healthcare-title ml-4 mb-4">
        Booked vacations
      </Modal.Title>
      {renderTableHealthcare(table, false)}
    </div>
  );
  return result;
};

export const renderTableVacationsRealEstate = (table, isScrollable = false, isFirstRowSticky = false, colIndexWithColor = -1) => {
  let result = [];

  const showVacationsTableWithClasses = (item, tableClass, theadClass) => {
    let tableDisplay = (
      <Table className={tableClass}>
        <thead className={theadClass}>
          <tr className={"text-left"}>
            {item.Columns.map((m, cindex) => {
              if (cindex == colIndexWithColor) {
                return getBookedVacationTooltip(
                  <th key={m?.Id} style={{ width: "150px" }}>
                    {m.Name.toUpperCase()}
                  </th>
                );
              } else {
                return (
                  <th key={m?.Id} style={{ width: "150px" }}>
                    {m.Name.toUpperCase()}
                  </th>
                );
              }
            })}
          </tr>
        </thead>
        <tbody className={"text-left"}>
          {item.Rows.map((tdata) => {
            return (
              <tr key={tdata?.Id}>
                {tdata.Data.map((trowdata, tindex) => {
                  let dateArray = trowdata?.Value?.split(",");
                  if (colIndexWithColor == tindex && dateArray?.length >= 3) {
                    return (
                      <td
                        key={trowdata?.Id}
                        style={{
                          color: getDateColor(dateArray[0]),
                        }}
                      >
                        {dateArray[1]} - {dateArray[2]}
                      </td>
                    );
                  } else {
                    return (
                      <td key={trowdata?.Id} className={"text-break"}>
                        {trowdata.Value}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    );

    return tableDisplay;
  };

  table.forEach((item) => {
    if (table != null && item != null) {
      if (item?.Columns != null) {
        let tableClass = "real-estate-table";
        let theadClass = "header";

        if (isScrollable) tableClass += " scrollable-table-real-estate";

        if (isFirstRowSticky) {
          theadClass += "rowSticky ";
          tableClass += " tableSticky";
        }

        result = showVacationsTableWithClasses(item, tableClass, theadClass);
      }
    }
  });

  return result;
};

export const renderTableMergersAndAcquisitions = (table, isDeals, isScrollable = false, isFirstRowSticky = false, colIndexWithColor = -1) => {
  let result = null;

  const showTableWithClasses = (item, tableClass, theadClass) => {
    let columnIdForColoring = 0;
    let tableDisplay = (
      <Table className={tableClass}>
        <thead className={theadClass}>
          <tr>
            {item.Columns.map((m, cindex) => {
              if (m?.Name.toLowerCase() == "time commitment") {
                if (m?.Id > 0) columnIdForColoring = m.Id;
              }
              if (cindex == colIndexWithColor) {
                return getBookedVacationTooltip(<th key={m?.Id} style={{ "width": "150px" }}>{m.Name.toUpperCase()}</th>);
              } else {
                return <th key={m?.Id} style={{ "width": "150px" }}>{m.Name.toUpperCase()}</th>;
              }
            })
            }
          </tr>
        </thead>
        <tbody className={isDeals ? "dropdown" : ""}>
          {item.Rows.map((tdata) => {
            return (
              <tr key={tdata?.Id}>
                {tdata.Data.map((trowdata, tindex) => {
                  let dateArray = trowdata?.Value?.split(',');
                  if (colIndexWithColor == tindex && dateArray?.length >= 3) {
                    return <td key={trowdata?.Id}
                      style={{
                        color: getDateColor(dateArray[0]),
                      }}
                    >
                      {dateArray[1]} - {dateArray[2]}
                    </td>
                  } else {
                    if (columnIdForColoring > 0 && trowdata?.ColumnId && trowdata.ColumnId == columnIdForColoring) {
                      let activeColor = "black";
                      if (trowdata.Value) {
                        if (trowdata.Value.toLowerCase() == "high") activeColor = "red";
                        if (trowdata.Value.toLowerCase() == "medium") activeColor = "orange";
                        if (trowdata.Value.toLowerCase() == "low") activeColor = "green ";
                      }
                      return <td key={trowdata?.Id} style={{ color: activeColor }} className={'text-break'}>{trowdata.Value}</td>;
                    } else {
                      return <td key={trowdata?.Id} className={'text-break'}>{trowdata.Value}</td>;
                    }
                  }
                })
                }
              </tr>
            );
          }
          )}
        </tbody>
      </Table>
    );

    return tableDisplay;
  }

  table.forEach((item) => {
    if (table != null && item != null) {
      if (item?.Columns != null) {
        let tableClass = "healthcare-table";
        let theadClass = "";

        if (isDeals) theadClass += "header sticky-row"
        if (isScrollable) tableClass += " scrollable-table-power-deals"

        if (isFirstRowSticky) {
          theadClass += "rowSticky "
          tableClass += " tableSticky"
        }
        result = showTableWithClasses(item, tableClass, theadClass);
      }
    }
  });

  return result;
};

export const renderTableDealsColumns = (columns, colIndexWithColor = -1) => {
  if (!columns || columns.length === 0) return null;

  let columnIdForColoring = 0;

  return (
    <thead className="header sticky-row">
      <tr>
        {columns.map((m, cindex) => {
          if (m?.Name && ["active?", "active ?", "active"].includes(m.Name.toLowerCase())) {
            if (m?.Id > 0) columnIdForColoring = m.Id;
          }

          let columnClass = 'min-width-column';
          if (["notes"].includes(m.Name.toLowerCase())) {
            columnClass = 'wide-column';
          } else if (["description"].includes(m.Name.toLowerCase())) {
            columnClass = 'medium-column';
          }

          const thElement = (
            <th key={m?.Id} className={columnClass}>{m.Name.toUpperCase()}</th>
          );

          return cindex === colIndexWithColor ? getBookedVacationTooltip(thElement) : thElement;
        })}
      </tr>
    </thead>
  );
};

export const renderTableDealsRows = (rows, colIndexWithColor = -1, columnIdForColoring = 0) => {
  if (!rows || rows.length === 0) return null;

  return (
    <tbody className="text-left">
      {rows.map((tdata) => (
        <tr key={tdata?.Id}>
          {tdata.Data.map((trowdata, tindex) => {
            const dateArray = trowdata?.Value?.split(',');
            if (colIndexWithColor === tindex && dateArray?.length >= 3) {
              return (
                <td key={trowdata?.Id}>
                  {dateArray[1]} - {dateArray[2]}
                </td>
              );
            } else if (columnIdForColoring > 0 && trowdata?.ColumnId === columnIdForColoring) {
              const activeValues = ["y", "yes", "active"].includes(trowdata.Value.toLowerCase());
              const activeClass = activeValues ? "active-color active-bg" : "inactive-color inactive-bg";
              const activeIcon = activeValues ? CheckmarkSquare : DismissSquare;
              return (
                <td key={trowdata?.Id}>
                  <span className={activeClass}>
                    {activeIcon && <img src={activeIcon} alt={`${trowdata?.Value || "ActiveInactive"}`} />}
                    {trowdata.Value}
                  </span>
                </td>
              );
            } else {
              return <td key={trowdata?.Id} className='text-break'>{trowdata.Value}</td>;
            }
          })}
        </tr>
      ))}
    </tbody>
  );
};

export const HoursWorkedThisWeek = [
  "hours worked in current week",
  "hours worked in current week?",
  "hours worked in current week!",
  "hours worked in the current week!",
  "hours worked this week",
  "hours worked on the current week"
];

export const WorkingOnWeekend = [
  "planning to work on the weekend?",
  "planning to work on the weekend",
  "are you planning to work on the weekend?",
  "are you planning to work on the weekend",
  "planning to work on weekend?",
  "planning working on the weekend?"
];

export const EstimatedHoursNextWeek = [
  "estimated hours for the next week",
  "estimated hours next week",
  "estimated hours the next week",
  "estimated hours next week"
];

export const renderTableWorklogColumns = (columns, colIndexWithColor = -1) => {
  if (!columns || columns.length === 0) return null;

  return (
    <thead className="header sticky-row">
      <tr>
        {columns.map((m, cindex) => {
          const columnName = m?.Name.trim().toLowerCase();

          if (columnName === "comments" || columnName === "comment") {
            return null;
          }

          if (HoursWorkedThisWeek.includes(columnName)) {
            return null;
          }
          if (WorkingOnWeekend.includes(columnName)) {
            return null;
          }
          if (EstimatedHoursNextWeek.includes(columnName)) {
            return null;
          }

          let columnClass = 'min-width-column';
          if (["notes"].includes(m.Name.toLowerCase())) {
            columnClass = 'wide-column';
          } else if (["description"].includes(m.Name.toLowerCase())) {
            columnClass = 'medium-column';
          }

          const thElement = (
            <th key={m?.Id} className={columnClass}>{m.Name.toUpperCase()}</th>
          );

          return cindex === colIndexWithColor ? getBookedVacationTooltip(thElement) : thElement;
        })}
      </tr>
    </thead>
  );
};

export const renderTableWorklogRows = (rows, columns) => {
  if (!columns || columns.length === 0) return null;
  if (!rows || rows.length === 0) return null;

  return (
    <tbody className="text-left">
      {rows.map((tdata) => (
        <tr key={tdata?.Id}>
          {tdata.Data.map((trowdata) => {
            let column = columns.find((c) => c.Id === trowdata.ColumnId);
            const columnName = column?.Name.trim().toLowerCase();

            if (column?.Name?.toLowerCase() === "comments" || column?.Name?.toLowerCase() === "comment") {
              return null;
            }

            if (columnName === "comments" || columnName === "comment") {
              return null;
            }

            if (HoursWorkedThisWeek.includes(columnName)) {
              return null;
            }
            if (WorkingOnWeekend.includes(columnName)) {
              return null;
            }
            if (EstimatedHoursNextWeek.includes(columnName)) {
              return null;
            }

            if (column?.Type?.toLowerCase() === "numeric (decimal)") {
              const value = parseFloat(trowdata.Value);
              const formattedValue = isNaN(value) || undefined || null ? "0.0" : value.toFixed(1);
              return <td key={trowdata?.Id} className='text-break'>{formattedValue}</td>;
            } else {
              return <td key={trowdata?.Id} className='text-break'>{trowdata.Value}</td>;
            }
          })}
        </tr>
      ))}
    </tbody>
  );
};

export const renderTableHealthcare = (table, isDeals, isScrollable = false, isFirstRowSticky = false, colIndexWithColor = -1) => {
  let result = null;

  const showTableWithClasses = (item, tableClass, theadClass) => {
    let tableDisplay = (
      <Table className={tableClass}>
        <thead className={theadClass}>
          <tr>
            {item.Columns.map((m, cindex) => {

              if (cindex == colIndexWithColor) {
                return getBookedVacationTooltip(<th key={m?.Id} style={{ "width": "150px" }}>{m.Name.toUpperCase()}</th>);
              }
              else {
                return <th key={m?.Id} style={{ "width": "150px" }}>{m.Name.toUpperCase()}</th>;
              }
            })}
          </tr>
        </thead>
        <tbody className={isDeals ? "dropdown" : ""}>
          {item.Rows.map((tdata) => {
            return (
              <tr key={tdata?.Id}>
                {tdata.Data.map((trowdata, tindex) => {
                  let dateArray = trowdata?.Value?.split(',');
                  if (colIndexWithColor == tindex && dateArray?.length >= 3) {
                    return <td key={trowdata?.Id}
                      style={{
                        color: getDateColor(dateArray[0]),
                      }}
                    >
                      {dateArray[1]} - {dateArray[2]}
                    </td>
                  }
                  else {
                    return <td key={trowdata?.Id} className={'text-break'}>{trowdata.Value}</td>;
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    );

    return tableDisplay;
  }

  table.forEach((item) => {
    if (table != null && item != null) {
      if (item?.Columns != null) {
        let tableClass = "healthcare-table";
        let theadClass = "";

        if (isDeals) {
          theadClass += "header sticky-row"
        }
        if (isScrollable) {
          tableClass += " scrollable-table-power-deals"
        }

        if (isFirstRowSticky) {
          theadClass += "rowSticky "
          tableClass += " tableSticky"
        }
        result = showTableWithClasses(item, tableClass, theadClass);
      }
    }
  });

  return result;
};

export const getCollapsedStatus = (accordionId) => {
  let accordions = document.getElementsByClassName(accordionId);
  for (let accordion of accordions) {
    if (accordion.classList.contains("show")) return false;
  }
  return true;
}

export const toggleAccordion = (accordionId) => {
  let accordion = document.getElementById(accordionId);
  if (accordion) {
    let collapsed = accordion.classList.contains("show");
    if (!collapsed) {
      accordion.classList.add("show");
    } else {
      accordion.classList.remove("show");
    }
  }
}

export const toggleAccordionOpen = (accordionId) => {
  let accordion = document.getElementById(accordionId);
  if (accordion) {
    let collapsed = accordion.classList.contains("show");
    if (!collapsed) {
      accordion.classList.add("show");
    }
  }
}

export const getHoursMinutes = (hour) => {
  try {
    let hourArray = hour.trim().split(" ");
    let hours = parseInt(hourArray[0].replace("h", ""));
    let minutes = parseInt(hourArray[1]?.replace("m", "")) ?? 0;

    return [hours, minutes];
  }
  catch {
    return null;
  }
}

export const sumHour = (hour1, hour2, isGib = false) => {
  if (!isValidHour(hour1)) {
    if (isValidHour(hour2)) {
      return getHoursMinutes(hour2) ? hour2 : "-";
    }
    return "-";
  }
  if (!isValidHour(hour2)) {
    return getHoursMinutes(hour1) ? hour1 : "-";
  }

  try {
    let hour1Array = getHoursMinutes(hour1);
    let hour2Array = getHoursMinutes(hour2);

    if (isGib) {
      let hours = sumHours(hour1Array, hour2Array);
      return hours > 0 ? `${hours}h` : "-";
    } else {
      let [hours, minutes] = sumHoursAndMinutes(hour1Array, hour2Array);
      return hours > 0 || minutes > 0 ? `${hours}h ${minutes}m` : "-";
    }
  } catch {
    return "-";
  }
};

const isValidHour = (hour) => hour && hour !== "-";

const sumHours = (hour1Array, hour2Array) => {
  let hours = 0;
  if (hour1Array && hour1Array.length > 0) hours += hour1Array[0];
  if (hour2Array && hour2Array.length > 0) hours += hour2Array[0];
  return hours;
};

const sumHoursAndMinutes = (hour1Array, hour2Array) => {
  let hours = 0;
  let minutes = 0;

  if (hour1Array && hour1Array.length > 0) {
    hours += hour1Array[0];
    minutes += hour1Array[1];
  }

  if (hour2Array && hour2Array.length > 0) {
    hours += hour2Array[0];
    minutes += hour2Array[1];
  }

  while (minutes > 59) {
    hours += 1;
    minutes -= 60;
  }

  return [hours, minutes];
};

export const isNumeric = (n) => {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export const isDate = (d) => {
  let mmdd = dayjs(d, "MM/DD/YYYY", true).isValid();
  let ddmm = dayjs(d, "DD/MM/YYYY", true).isValid();
  let yyyy = dayjs(d, "YYYY-MM-DD", true).isValid();

  if (mmdd && !ddmm) {
    return "MM/DD/YYYY"
  }
  else if (ddmm && !mmdd) {
    return "DD/MM/YYYY"
  }
  else if (ddmm && mmdd) {
    // Pending verify user preferences here
    return "MM/DD/YYYY"
  }
  else if (yyyy) {
    return "YYYY-MM-DD"
  }
  else {
    return false;
  }
}

export const timeToInt = (t) => {
  try {
    let tArray = t.split(' ');
    let hours = +(tArray[0].replace('h', ''));
    let minutes = +(tArray[1].replace('m', ''));
    return (hours * 60) + minutes;
  }
  catch {
    return 0;
  }
}

export const useSortableData = (items, config = null) => {
  const [sortConfig, setSortConfig] = useState(config);
  const defaultComparision = (a, b) => {
    if (typeof a == "string") {
      if (a?.toLowerCase() < b?.toLowerCase()) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a?.toLowerCase() > b?.toLowerCase()) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
    } else if (Array.isArray(a) && Array.isArray(b)) {
      const aLength = a.length;
      const bLength = b.length;
      if (aLength < bLength) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (aLength > bLength) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    }
    else {
      if (a < b) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a > b) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
    }
    return 0;
  }
  const parseCompletionTime = (timeStr) => {
    if (timeStr === "No Completed Tasks") return -1;

    let totalMinutes = 0;
    const timeParts = timeStr.split(' ');

    timeParts.forEach(part => {
      const value = parseInt(part.slice(0, -1));
      const unit = part.slice(-1);

      if (unit === 'd') {
        totalMinutes += value * 24 * 60;
      } else if (unit === 'h') {
        totalMinutes += value * 60;
      } else if (unit === 'm') {
        totalMinutes += value;
      }
    });

    return totalMinutes;
  };
  const sortedItems = useMemo(() => {

    if (sortConfig !== null) {
      if (sortConfig.key === "AverageCompletionTime") {
        let sortableItems = [...items];
        sortableItems.sort((valueA, valueB) => {
          let a = parseCompletionTime(valueA[sortConfig.key]);
          let b = parseCompletionTime(valueB[sortConfig.key]);
          return defaultComparision(a, b);
        });
        return sortableItems;
      }
      if (sortConfig.key === "CMEdormant" || sortConfig.key === "CMEactive") {
        let sortableItems = (sortConfig.key === "CMEdormant") ? [...items.Dormant] : [...items.Active];
        sortableItems.sort((valueA, valueB) => {
          let a = valueA['ProjectDynamicFields']?.[0]?.Data;
          let b = valueB['ProjectDynamicFields']?.[0]?.Data;
          return defaultComparision(a, b)
        });
        return (sortConfig.key === "CMEdormant") ? [items, ...items.Dormant = sortableItems] : [items, ...items.Active = sortableItems];
      }
    }
    if (items && items.length == 1) {
      return [...items]
    }
    if (items && items.length > 1) {
      let sortableItems = [...items];
      if (sortConfig !== null) {
        sortableItems.sort((valueA, valueB) => {
          let a = valueA[sortConfig.key]
          let b = valueB[sortConfig.key]

          if (sortConfig.key === "Project.Name") {
            a = valueA['Project']?.Name;
            b = valueB['Project']?.Name;
          }

          if (sortConfig.key === "Project.End") {
            a = valueA['Project']?.End;
            b = valueB['Project']?.End;
          }

          if (sortConfig.key === "Project.Members") {
            let membersA = valueA['Project']?.Members;
            let membersB = valueB['Project']?.Members;

            let ownerIdA = valueA['Project']?.Owner?.Id;
            let ownerIdB = valueB['Project']?.Owner?.Id;

            let ownerA = membersA.find((element) => element.UserId === ownerIdA);
            let ownerB = membersB.find((element) => element.UserId === ownerIdB);

            a = ownerA?.User?.Name;
            b = ownerB?.User?.Name;
          }

          let isDateA = isDate(a);
          let isDateB = isDate(b);
          let isTimeA = a?.Time ?? false;
          let isTimeB = b?.Time ?? false;

          if (isDateA || isDateB) {
            // isDateA/isDateB are format strings ("MM/DD/YYYY" etc.) returned by isDate(),
            // or `false` if the value isn't a recognized date. Use the detected format
            // for strict parsing; fall back to dayjs's default parser when only one side
            // detected a format (the other value will simply be Invalid Date).
            let dayA = isDateA ? dayjs(a, isDateA, true) : dayjs(a);
            let dayB = isDateB ? dayjs(b, isDateB, true) : dayjs(b);

            let dateA = new Date(0);
            let dateB = new Date(0);
            if (dayA.isValid()) {
              dateA = dayA.toDate();
            }

            if (dayB.isValid()) {
              dateB = dayB.toDate();
            }

            return defaultComparision(dateA, dateB)
          }
          if (isTimeA || isTimeB) {
            let timeA = 0;
            let timeB = 0;

            if (isTimeA) {
              timeA = timeToInt(isTimeA)
            }

            if (isTimeB) {
              timeB = timeToInt(isTimeB)
            }

            if (sortConfig.direction === 'descending') {
              return timeB - timeA
            }
            else {
              return timeA - timeB
            }
          }
          if (sortConfig.key === "OverallCapacity") {
            switch (a) {
              case "High":
                if (b === "Medium" || b === "Low") {
                  return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                return defaultComparision(a, b ? b : "")
              case "Medium":
                if (b === "Low") {
                  return sortConfig.direction === 'ascending' ? -1 : 1;
                }
                if (b === "High") {
                  return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return defaultComparision(a, b ? b : "")
              case "Low":
                if (b === "Medium" || b === "High") {
                  return sortConfig.direction === 'ascending' ? 1 : -1;
                }
                return defaultComparision(a, b ? b : "")
              default:
                return defaultComparision(a ? a : "", b ? b : "")
            }
          }
          else {
            return defaultComparision(a, b)
          }
        });
      }
      return sortableItems;
    }
    else {
      return [];
    }
  }, [items, sortConfig]);

  const requestSort = key => {
    let direction = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'descending') {
      setSortConfig(null);
    }
    else {
      setSortConfig({ key, direction });
    }
  }

  const getArrowDirectionFor = (name, direction) => {
    if (!direction) {
      return sortConfig?.key !== name;
    }
    if (!sortConfig) {
      return false;
    }
    return sortConfig.key === name ? sortConfig.direction === direction : false;

  }

  return { items: sortedItems, requestSort, getArrowDirectionFor };
}

const Colors = [
  "#F1949D", "#FFD66B", "#6BB0E8", "#B9A4D5", "#6BE1A8",
  "#E95764", "#FFBF15", "#1583DA", "#9171BE", "#15D076",
  "#C03C47", "#D49A00", "#0064B3", "#705399", "#00AA58",
  "#F9D1D5", "#FFEDBF", "#BFDDF5", "#E1D8ED", "#BFF2DA"
];

export const getRandomColors = (count) => {
  const shuffledColors = Colors.sort(() => 0.5 - Math.random());
  return shuffledColors.slice(0, count);
};

export const categoryDisplayMappings = {
  Status: "Status",
  Priority: "Priority",
  TriggerSource: "Triggering Source",
  Department: "Department",
  BranchLocation: "Branch Location",
  TriggerType: "Trigger Type",
};

export const reverseCategoryMappings = Object.fromEntries(
  Object.entries(categoryDisplayMappings).map(([key, display]) => [display, key])
);

export const formatLabels = (labels) => {
  const uniqueYears = new Set(labels.map(label => dayjs(label, 'MMM DD, YYYY').year()));
  return labels.map(label => {
    const formattedDate = dayjs(label, 'MMM DD, YYYY');
    return uniqueYears.size > 1 ? formattedDate.format('MMM DD, YYYY') : formattedDate.format('MMM DD');
  });
};

export const REProjectHeaders = [
  { text: "PROJECT NAME", sortKey: "ProjectName", colClass: "col-md-3 col-sm-3" },
  { text: "MEMBERS", sortKey: "ProjectMembersList", colClass: "col-md-3 col-sm-3" },
  { text: "STATUS", sortKey: "Status", colClass: "col-md-2 col-sm-2" },
  { text: "ACTIVE", sortKey: "Active", colClass: "col-md-2 col-sm-2" },
  { text: "HOURS WORKED IN CURRENT WEEK", sortKey: "HoursWorkedInCurrentWeek", colClass: "col-md-2" },
  { text: "# PLANNING TO WORK ON THE WEEKEND", sortKey: "CountWorkingOnTheWeekend", colClass: "col-md-2" },
  { text: "ESTIMATED HOURS FOR THE NEXT WEEK", sortKey: "HoursForTheNextWeek", colClass: "col-md-2" },
  { text: "MD", sortKey: "MD", colClass: "col-md-2 col-sm-2" },
  { text: "D/SVP", sortKey: "D", colClass: "col-md-2 col-sm-2" },
  { text: "VP", sortKey: "VP", colClass: "col-md-2 col-sm-2" },
  { text: "ASSOCIATE", sortKey: "Associate", colClass: "col-md-2 col-sm-2" },
  { text: "ANALYST", sortKey: "Analyst", colClass: "col-md-2 col-sm-2" },
  { text: "DESCRIPTION", sortKey: "Description", colClass: "col-md-3 col-sm-3" },
];

export const renderStatus = (status, statusColor) => {
  const [backgroundColor, textColor] = statusColor.split("|");

  return (
    <span style={{
      backgroundColor,
      color: textColor,
      padding: "5px",
      borderRadius: "4px",
      display: "inline-block",
      margin: "5px 0",
      marginRight: "5px",
      alignItems: "center",
    }}>
      {status}
    </span>
  );
};

export const renderActive = (active) => {
  const styles = {
    padding: "5px",
    borderRadius: "4px",
    display: "inline-flex",
    alignItems: "center",
    margin: "5px 0",
    marginRight: "5px",
  };

  if (active === 1) {
    return (
      <span style={{ ...styles, backgroundColor: "#EBF5ED", color: "#1D7D2C" }}>
        <img src={CheckmarkSquare} alt="Active" style={{ marginRight: "5px" }} />
        <span>Active</span>
      </span>
    );
  } else {
    return (
      <span style={{ ...styles, backgroundColor: "#FDE8E8", color: "#C11919" }}>
        <img src={DismissSquare} alt="Inactive" style={{ marginRight: "5px" }} />
        <span>Inactive</span>
      </span>
    );
  }
};

export const renderMemberCell = (memberName) => (
  <td className="col-md-1 col-sm-1 mt-2">
    {memberName ? (
      <div className="violationContainer">
        <div className="violationIconContainer">
          <div className="member-icon-user d-flex align-items-center">
            <div className="member-icon-initials-user">
              {getInitials(memberName)}
            </div>
          </div>
        </div>
        {memberName}
      </div>
    ) : "-"}
  </td>
);


export const RedirectToTask = ({ CanEdit = false, TaskId, TaskName }) => {
  return (
    <div className="edit-button-container">
      <OverlayTrigger
        placement={"bottom"}
        delay={{ show: 150, hide: 150 }}
        overlay={
          <Tooltip className="actionToolTip">
            {CanEdit
              ? `Edit '${TaskName}' Task`
              : "You do not have the requisite Member Permissions to Edit this Task"}
          </Tooltip>
        }
      >
        <div>
          {CanEdit ? (
            <Link
              to={`/tasks/edit/std/${TaskId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="dashboard-edit-btn">
                <img
                  disabled={!CanEdit}
                  alt="edit"
                  src={DashboardEdit}
                />
              </div>
            </Link>
          ) : (
            <div className="dashboard-edit-btn">
              <img
                disabled={!CanEdit}
                alt="edit"
                src={DashboardEdit}
              />
            </div>
          )}
        </div>
      </OverlayTrigger>
    </div>
  );
};

export const MeBadge = () => {
  return (
    <FluentBadge
      shape="circular"
      appearance="tint"
      size="medium"
      text={"Me"}
      color="important"
    />
  );
};

export const NameAndBadge = ({ name }) => {
  return (
    <div className="dashboardNameTextContainer">
      <FluentTooltip
        target={<span className="dashboardNameText">{name}</span>}
        text={name}
        positioning="above"
      />
      <div className="me-2 ml-2">
        <MeBadge />
      </div>
    </div>
  );
};

export const NameAndNoDealsBadge = ({ name, onRowClick, activeDeals = true, text = "Deals" }) => {
  const renderBadge = !activeDeals;
  const badgeText = `No Active ${text}`;

  return (
    <div className="dashboardNameTextContainer" style={{ pointerEvents: 'none' }}>
      <FluentTooltip
        target={<span onClick={onRowClick} className="dashboardNameText" style={{ pointerEvents: 'auto' }}>{name}</span>}
        text={name}
        positioning="above"
      />
      {renderBadge && (
        <div className="me-2 ml-2" style={{ pointerEvents: 'none' }}>
          <FluentBadge
            appearance="filled"
            size="small"
            color="informative"
            text={badgeText}
          />
        </div>
      )}
    </div>
  );
};